import React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetSection,
  ModalSheetHeaderShell,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import Button from 'components/Button'
import styles from './ManageItemsInBundle.m.sass'
import ManageIncludedItemsViewModel, {
  IncludedItemViewModel,
} from './ManageItemsInBundleViewModel'
import { SwitchCheckbox } from 'components/SwitchCheckbox'
import Checkbox from 'components/Checkbox'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import SearchField from 'components/SearchField'

interface Props {
  vm: ManageIncludedItemsViewModel
}

export default observer(function ManageItemsInBundleViewModalForm({
  vm,
}: Props) {
  return (
    <ModalSheet
      disableCloseOnOutsideClick
      showing={vm.showing}
      onRequestClose={vm.close}
    >
      <ModalSheetHeaderShell size="auto">
        <div className={styles.headerShell}>
          <div className={styles.header}>
            <div className={styles.title}>Add service Items</div>
            <div className={styles.closeButtonContainer}>
              <ModalSheetHeaderCloseButton />
            </div>
          </div>
          <div className={styles.searchContainer}>
            <SearchField
              autoFocus
              stretch
              className={styles.search}
              placeholder="Type to search service items"
              onChange={vm.searchText.change}
              value={vm.searchText.value}
              showClearButton
              dataTest="bundle-included-items-modal-search-field"
            />
          </div>
        </div>
      </ModalSheetHeaderShell>

      <ModalSheetContent>
        <ModalSheetSection spaced>
          <div className={styles.heading}>
            <div>Select all that apply</div>
            <div>Mark as base item</div>
          </div>
          <div>
            {vm.serviceItems.map((includedItemVM, index) => (
              <IncludedItemSelector
                key={index}
                includedItemVM={includedItemVM}
                manageIncludedItemsVM={vm}
              />
            ))}
            {!vm.inventoryScrollProvider.isDone && (
              <InfiniteScrollLoader
                scrollProvider={vm.inventoryScrollProvider}
              />
            )}
          </div>
        </ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            dataTest="bundle-included-items-modal-close-button"
            onClick={vm.close}
            type="default"
          >
            Close
          </Button>

          <Button
            onClick={vm.submit}
            form="addItemForm"
            type="primary"
            dataTest="bundle-included-items-modal-assign-button"
          >
            {`Assign ${vm.totalSelected}`}
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

interface IncludedItemSelectorProps {
  manageIncludedItemsVM: ManageIncludedItemsViewModel
  includedItemVM: IncludedItemViewModel
}

const IncludedItemSelector = observer(function ({
  manageIncludedItemsVM,
  includedItemVM,
}: IncludedItemSelectorProps) {
  return (
    <div className={styles.includedItem}>
      <div className={styles.selectorContainer}>
        <label className={styles.label}>
          <Checkbox
            checked={includedItemVM.isIncludedItem}
            onChange={includedItemVM.toggleIncludedItem}
            data-test={`bundle-included-item-modal-checkbox-${includedItemVM.name}`}
          />
          <div className={styles.itemInfo}>
            <div className={styles.labelText}>{includedItemVM.name}</div>
            <div className={styles.labelDescription}>
              {includedItemVM.description}
            </div>
          </div>
        </label>
      </div>

      <div>
        <SwitchCheckbox
          noText
          disabled={
            manageIncludedItemsVM.isBaseItemToggled &&
            !includedItemVM.isBaseItem
          }
          value={includedItemVM.isBaseItem}
          onChange={includedItemVM.toggleBaseItem}
          data-test={`bundle-included-item-modal-switchcheckbox-${includedItemVM.name}`}
        />
      </div>
    </div>
  )
})
